import { render, staticRenderFns } from "./CreateTicker.vue?vue&type=template&id=3978898d&scoped=true"
import script from "./CreateTicker.vue?vue&type=script&lang=js"
export * from "./CreateTicker.vue?vue&type=script&lang=js"
import style0 from "./CreateTicker.vue?vue&type=style&index=0&id=3978898d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978898d",
  null
  
)

export default component.exports